// ProductTable.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import QuantityControl from '../../components/utility/QuantityControl'; // Assuming QuantityControl is in a separate file
import AddToCard from '../../components/utility/AddToCard'; // Assuming AddToCard is in a separate file
import minus from '../../assets/img/minus.png'; // Adjust path as needed
import plus from '../../assets/img/plus.png'; // Adjust path as needed

const ProductTable = ({
  currentProducts,
  expandedRow,
  toggleExpandRow,
  getCurrencySymbol,
  calculatePrice,
  counters,
  handleInputChange,
  increment,
  decrement,
  openPopup,
  selectedItems,
  handleSelectAll,
  handleSelectItem,
  shopnow,
  priceDisplay,
  getPriceForQuantity,   // <-- add this
}) => {
  return (
    <div className="overflow-x-auto">
      <div className="rounded-lg ring-1 ring-slate-900/10 table-container min-w-full">
        <div className="w-full overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-gray-500 text-[1rem] text-gray-500">
                <th className="px-2 py-2">Name</th>
                <th className="px-2 py-2 text-center">Bore (B)</th>
                <th className="px-2 py-2">Thick (t)</th>
                <th className="px-2 py-2">Thickness Tolerance</th>
                <th className="px-2 py-2">Free Diameter (D)</th>
                <th className="px-2 py-2">Clearance on Bore (Cb)</th>
                <th className="px-2 py-2">Beam (b)</th>
                <th className="px-2 py-2">Price</th>
                <th className="px-2 py-2">Buy</th>
                <th className="px-2 py-2 flex gap-2">
                  Select All
                  <input
                    className="w-[15px]"
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={
                      selectedItems.length === currentProducts.length &&
                      currentProducts.length > 0
                    }
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentProducts.map((product) => {
                const userQty = counters[product.id] || 1;
                const storedQty = priceDisplay === "per100" ? userQty * 100 : userQty;
                const { price: unitPrice, tier } = getPriceForQuantity(product, storedQty);

                return (
                  <React.Fragment key={product.id}>
                    <tr className="odd:bg-gray-100 border-b border-gray-300 text-base">
                      <td className="px-2 py-4 whitespace-nowrap flex gap-1 font-semibold text-gray-500">
                        <img
                          src={expandedRow === product.id ? minus : plus}
                          alt={expandedRow === product.id ? "Collapse" : "Expand"}
                          className="w-[20px] cursor-pointer"
                          onClick={() => toggleExpandRow(product.id)}
                        />
                        {product.name}
                      </td>
                      <td className="px-2 py-2 text-center">{product.bore}</td>
                      <td className="px-2 py-2">{product.thick}</td>
                      <td className="px-2 py-2">
                        +{product.thickness_tolerance}
                      </td>
                      <td className="px-2 py-2">{product.free_diameter}</td>
                      <td className="px-2 py-2">
                        {product.clearance_onbore}
                      </td>
                      <td className="px-2 py-2">{product.beam}</td>

                      {/* Dynamic price based on quantity */}
                      <td className="px-2 py-2">
                        {unitPrice ? (
                          <span>
                            {getCurrencySymbol()}{" "}
                            {Number(calculatePrice(unitPrice)).toFixed(2)}
                            <span className="block text-[10px] text-gray-400">
                              Tier: {tier}
                            </span>
                          </span>
                        ) : (
                          "POA"
                        )}
                      </td>

                      <td className="px-2 py-2">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
                          {unitPrice ? (
                            <QuantityControl
                              value={userQty}
                              onChange={(e) => handleInputChange(e, product.id)}
                              increment={() => increment(product.id)}
                              decrement={() => decrement(product.id)}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>

                      <td className="px-2 py-2 flex gap-2">
                        {unitPrice ? (
                          <>
                            <div className="mt-1 sm:mt-0">
                              <AddToCard
                                product={product}
                                quantity={userQty}
                                priceDisplay={priceDisplay}
                                openPopup={() => openPopup(product, userQty)}
                              />
                            </div>
                            <input
                              className="w-[15px]"
                              type="checkbox"
                              checked={selectedItems.includes(product.id)}
                              onChange={() => handleSelectItem(product.id)}
                            />
                          </>
                        ) : (
                          <button
                            className="bg-[#ef3f33] hover:bg-[#81d742] text-white p-1 rounded font-semibold"
                            onClick={() => shopnow(product.id)}
                          >
                            Read more
                          </button>
                        )}
                      </td>
                    </tr>

                    {/* Expandable row - update prices similarly */}
                    {expandedRow === product.id && (
                      <tr>
                        <td colSpan={13} className="px-2 py-0 bg-white">
                          <ul>
                            {/* ... keep existing fields ... */}

                            <li className="px-5 border-b border-gray-200 flex">
                              <span className="block w-[75px] text-base font-bold text-gray-600">
                                Price 250-999
                              </span>
                              <span className="w-[55%] text-gray-600 text-base font-semibold mx-4">
                                {product.price_250_999
                                  ? `${getCurrencySymbol()} ${Number(
                                      calculatePrice(product.price_250_999)
                                    ).toFixed(2)}`
                                  : "POA"}
                              </span>
                            </li>
                            <li className="px-5 border-b border-gray-200 flex">
                              <span className="block w-[75px] text-base font-bold text-gray-600">
                                Price 1000-4999
                              </span>
                              <span className="w-[55%] text-gray-600 text-base font-semibold mx-4">
                                {product.price_1000_4999
                                  ? `${getCurrencySymbol()} ${Number(
                                      calculatePrice(product.price_1000_4999)
                                    ).toFixed(2)}`
                                  : "POA"}
                              </span>
                            </li>
                            <li className="px-5 border-b border-gray-200 flex">
                              <span className="block w-[75px] text-base font-bold text-gray-600">
                                Price 5000-9999
                              </span>
                              <span className="w-[55%] text-gray-600 text-base font-semibold mx-4">
                                {product.price_5000_9999
                                  ? `${getCurrencySymbol()} ${Number(
                                      calculatePrice(product.price_5000_9999)
                                    ).toFixed(2)}`
                                  : "POA"}
                              </span>
                            </li>
                            <li className="px-5 border-b border-gray-200 flex">
                              <span className="block w-[75px] text-base font-bold text-gray-600">
                                Price 10000+
                              </span>
                              <span className="w-[55%] text-gray-600 text-base font-semibold mx-4">
                                {product.price_10000plus
                                  ? `${getCurrencySymbol()} ${Number(
                                      calculatePrice(product.price_10000plus)
                                    ).toFixed(2)}`
                                  : "POA"}
                              </span>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductTable;